import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ScrollArea = styled(Box)(({ theme }) => ({
  width: "100%",
  flex: "1 1 auto",
  overflow: "auto",
  position: "relative",
  paddingBottom: theme.spacing(10),
}));
